import { WorkflowActionId } from "@sp-crm/core";

export interface WorkflowExecutionActionSource {
    actionId: WorkflowActionId | null;
    workflow: { actions: ReadonlyArray<{ id: WorkflowActionId | null }> };
}

export const executionActionLabel = (
    execution: WorkflowExecutionActionSource,
): string | null => {
    const actions = execution.workflow.actions;
    if (actions.length <= 1 || !execution.actionId) {
        return null;
    }
    const position = actions.findIndex(action => action.id === execution.actionId);
    return position === -1 ? null : `Action ${position + 1} of ${actions.length}`;
};
